import React from 'react';
import { CrmInput } from '../ui/CrmFormControls';
import { formatCurrency } from '../../utils/currencyUtils';

function InvoiceSummary({ totals, currency, pricingMode = 'EXCLUSIVE', roundingAmount = 0, setRoundingAmount = () => {} }) {
  const gstLabel = pricingMode === 'INCLUSIVE' ? 'GST (included)' : 'GST (exclusive)';
  const tax = (totals.cgst_total || 0) + (totals.sgst_total || 0) + (totals.igst_total || 0);
  return <div className="workspace-document-summary">
    <div><span>Subtotal</span><strong>{formatCurrency(totals.subtotal, currency)}</strong></div>
    <div><span>{gstLabel}</span><strong>{formatCurrency(tax, currency)}</strong></div>
    <CrmInput className="workspace-document-summary__rounding" label={`Rounding +/- (${currency})`} type="number" step="0.01" value={roundingAmount ?? 0} onChange={(event) => setRoundingAmount(Number(event.target.value || 0))} />
    <div className="workspace-document-summary__total"><span>Grand total</span><strong>{formatCurrency(totals.grand_total, currency)}</strong></div>
  </div>;
}

export default InvoiceSummary;
